const TICK_STEPS = [1, 2, 3, 4, 6, 12, 24, 48]
const MIN_TICK_SPACING = 24

function getLabelCount(valueCount: number, step: number) {
  return Math.floor((valueCount - 1) / step) + 1
}

/**
 * Widens the every-nth tick step until the labels fit the chart width; unmeasured or wide charts keep `threshold`
 */
export function getFittedTickStep(threshold: number, valueCount: number, width: number): number {
  if (width <= 0 || valueCount <= 0) {
    return threshold
  }
  const maxLabels = Math.max(2, Math.floor(width / MIN_TICK_SPACING))
  if (getLabelCount(valueCount, threshold) <= maxLabels) {
    return threshold
  }
  return (
    TICK_STEPS.find((step) => step > threshold && getLabelCount(valueCount, step) <= maxLabels) ??
    Math.ceil((valueCount - 1) / (maxLabels - 1))
  )
}
